import React from 'react';
import TextField from "@mui/material/TextField";
import { format } from "date-fns";
import { getDurationLabel } from "../../../Helpers/DateTimeHelper";

const AvailabilityIntervalSelectorDisabled = (props) => {

    if (!props.startTime) {
        return null;
    }

    return(<>
        <div className="grid-x">
            <div className="small-12 medium-5">
                <label>Start</label>
                <TextField
                    value={format(props.startTime, 'HH:mm')}
                    disabled
                />
            </div>

            <div className="small-12 medium-7 padding-left-half">
                <label>Duration</label>
                <TextField
                    value={getDurationLabel(props.duration)}
                    disabled
                />
            </div>
        </div>

        {/* Yes, we drilled this prop all the way down here just so we can show this error message even if the user hasn't submitted to the server yet */}
        {(!props.startTimeErrorMessage) && (
            <small className="error">
                {props.message}
            </small>
        )}
    </>);
}

AvailabilityIntervalSelectorDisabled.defaultProps = {
    message: "Booking details can no longer be changed as the booking is now underway. Please click cancel to close the form."
}
export default AvailabilityIntervalSelectorDisabled;

